import { BaseModel } from "./base.model"
import { Moment } from "moment"

export class Notification extends BaseModel<Notification> {
  role: string
  comment: string
  read: boolean
  notificatibleType: string
  notificatibleId: number
  createdAt: Moment
  source: string
  checked: boolean

  get readText(): string {
    if (this.read) {
      return "Прочитано"
    } else {
      return "Не прочитано"
    }
  }

  get commentText(): string {
    let tmp = document.createElement("DIV")
    tmp.innerHTML = this.comment

    return tmp.textContent || tmp.innerText || ""
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/notification.model.ts